// extracted by mini-css-extract-plugin
export var active = "MenuEntry-module--active--3997e";
export var arrowUpAndDown = "MenuEntry-module--arrow-up-and-down--99003";
export var headerWithOpaqueBackground = "MenuEntry-module--headerWithOpaqueBackground--c94e1";
export var link = "MenuEntry-module--link--5e807";
export var mobile = "MenuEntry-module--mobile--40f47";
export var morePaddingLeft = "MenuEntry-module--morePaddingLeft--b2c99";